import type {PillProps} from 'src/design/atoms/Pill';
import type {SectionValidationResult} from 'src/shared/hooks/SectionValidationContext';

export const FormBuilderPillConfig = (
  status: boolean,
  subformOnly: boolean
): PillProps[] => {
  const pills: PillProps[] = [];
  switch (status) {
    case true:
      pills.push({text: 'Active', color: 'green'});
      break;
    case false:
      pills.push({text: 'Inactive', color: 'yellow'});
      break;
    default:
      break;
  }

  if (subformOnly === true) {
    pills.push({text: 'Subform', color: 'gray'});
  }

  return pills;
};

export const FormBuilderDocumentTitle = 'Form Builder';

export const buildSectionValidationMessage = (
  results: SectionValidationResult[]
): string | null => {
  const invalidLabels = results.filter(r => !r.valid).map(r => r.label);

  if (invalidLabels.length === 0) {
    return null;
  }

  const joined = invalidLabels.join(' and ');
  const capitalized = joined.charAt(0).toUpperCase() + joined.slice(1);

  return `${capitalized} contain errors — review the highlighted fields.`;
};
